import { render, staticRenderFns } from "./forgetpass.vue?vue&type=template&id=714363e4&scoped=true"
import script from "./forgetpass.vue?vue&type=script&lang=js"
export * from "./forgetpass.vue?vue&type=script&lang=js"
import style0 from "./forgetpass.vue?vue&type=style&index=0&id=714363e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714363e4",
  null
  
)

export default component.exports